class NewCarousel extends window.BAO.CarouselElement {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.initializeCarousel()
  }

  initializeCarousel () {
    if (!this.els?.slides?.exists || !this.slide.exists) return

    // eslint-disable-next-line no-undef
    return new KeenSlider(this.els.slides.element, {
      selector: this.els.slide.selector,
      drag: true,
      loop: false,
      mode: 'snap',
      rubberband: false,
      slides: {
        origin: 'auto',
        perView: this.numberOfSlidesMobile,
        spacing: 20,
      },
      breakpoints: {
        '(min-width: 901px)': {
          slides: {
            perView: this.numberOfSlidesTablet,
            spacing: 20,
          },
        },
        '(min-width: 1201px)': {
          slides: {
            perView: this.numberOfSlidesDesktop,
            spacing: 20,
          },
        },
      },
    })
  }

  get numberOfSlidesMobile () {
    return this.slides?.dataset.slidesMobile
  }

  get numberOfSlidesTablet () {
    return this.slides?.dataset.slidesTablet
  }

  get numberOfSlidesDesktop () {
    return this.slides?.dataset.slidesDesktop
  }

  get slides () {
    return this.els?.slides?.element
  }

  get slide () {
    return this.els?.slide
  }
}

if (!customElements.get('new-carousel')) {
  customElements.define('new-carousel', NewCarousel)
}
